import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mt-8 intro-y" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-lg font-medium" }, "Modal")
], -1)
const _hoisted_2 = { class: "grid grid-cols-12 gap-6 mt-5" }
const _hoisted_3 = { class: "col-span-12 intro-y lg:col-span-6" }
const _hoisted_4 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, "Blank Modal", -1)
const _hoisted_6 = { class: "p-5" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, "Modal Size", -1)
const _hoisted_10 = { class: "p-5" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, "Warning Modal", -1)
const _hoisted_14 = { class: "p-5" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "p-5 text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 text-3xl" }, "Oops...", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-slate-500" }, "Something went wrong!", -1)
const _hoisted_19 = { class: "px-5 pb-8 text-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "p-5 text-center border-t border-slate-200/60 dark:border-darkmode-400" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "",
    class: "text-primary"
  }, " Why do I have this issue? ")
], -1)
const _hoisted_21 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, "Modal With Close Button", -1)
const _hoisted_23 = { class: "p-5" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "p-5 text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 text-3xl" }, "Modal Example", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-slate-500" }, "Modal with close button", -1)
const _hoisted_28 = { class: "px-5 pb-8 text-center" }
const _hoisted_29 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, "Static Backdrop Modal", -1)
const _hoisted_31 = { class: "p-5" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, " I will not close if you click outside me. Don't even try to press escape key. ", -1)
const _hoisted_35 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, "Overlapping Modal", -1)
const _hoisted_37 = { class: "p-5" }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, " Click button bellow to show overlapping modal! ", -1)
const _hoisted_41 = { class: "col-span-12 intro-y lg:col-span-6" }
const _hoisted_42 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, "Header & Footer Modal", -1)
const _hoisted_44 = { class: "p-5" }
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, " Broadcast Message ", -1)
const _hoisted_47 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_48 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_49 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_50 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_51 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_52 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", null, "10", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", null, "25", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("option", null, "35", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", null, "50", -1)
const _hoisted_57 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, "Delete Modal", -1)
const _hoisted_59 = { class: "p-5" }
const _hoisted_60 = { class: "text-center" }
const _hoisted_61 = { class: "p-5 text-center" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 text-3xl" }, "Are you sure?", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-slate-500" }, [
  /*#__PURE__*/_createTextVNode(" Do you really want to delete these records? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" This process cannot be undone. ")
], -1)
const _hoisted_64 = { class: "px-5 pb-8 text-center" }
const _hoisted_65 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, "Success Modal", -1)
const _hoisted_67 = { class: "p-5" }
const _hoisted_68 = { class: "text-center" }
const _hoisted_69 = { class: "p-5 text-center" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 text-3xl" }, "Good job!", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-slate-500" }, "You clicked the button!", -1)
const _hoisted_72 = { class: "px-5 pb-8 text-center" }
const _hoisted_73 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, "Tiny Slider Modal", -1)
const _hoisted_75 = { class: "p-5" }
const _hoisted_76 = { class: "text-center" }
const _hoisted_77 = { class: "mx-6" }
const _hoisted_78 = { class: "h-56 px-2" }
const _hoisted_79 = { class: "h-full overflow-hidden rounded-md image-fit" }
const _hoisted_80 = ["src"]
const _hoisted_81 = { class: "h-56 px-2" }
const _hoisted_82 = { class: "h-full overflow-hidden rounded-md image-fit" }
const _hoisted_83 = ["src"]
const _hoisted_84 = { class: "h-56 px-2" }
const _hoisted_85 = { class: "h-full overflow-hidden rounded-md image-fit" }
const _hoisted_86 = ["src"]
const _hoisted_87 = { class: "h-56 px-2" }
const _hoisted_88 = { class: "h-full overflow-hidden rounded-md image-fit" }
const _hoisted_89 = ["src"]
const _hoisted_90 = { class: "flex flex-col items-center p-5 border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-base font-medium" }, " Programmatically Show/Hide Modal ", -1)
const _hoisted_92 = { class: "p-5" }
const _hoisted_93 = { class: "text-center" }

import Preview from "../base-components/Preview";
import {
  FormLabel,
  FormSwitch,
  FormInput,
  FormSelect,
} from "../base-components/Form";
import { Menu, Dialog } from "../base-components/Headless";
import TinySlider from "../base-components/TinySlider";
import Button from "../base-components/Button";
import Lucide from "../base-components/Lucide";
import fakerData from "../utils/faker";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  setup(__props) {

const basicModalPreview = ref(false);
const setBasicModalPreview = (value: boolean) => {
  basicModalPreview.value = value;
};
const smallModalSizePreview = ref(false);
const setSmallModalSizePreview = (value: boolean) => {
  smallModalSizePreview.value = value;
};
const mediumModalSizePreview = ref(false);
const setMediumModalSizePreview = (value: boolean) => {
  mediumModalSizePreview.value = value;
};
const largeModalSizePreview = ref(false);
const setLargeModalSizePreview = (value: boolean) => {
  largeModalSizePreview.value = value;
};
const superlargeModalSizePreview = ref(false);
const setSuperlargeModalSizePreview = (value: boolean) => {
  superlargeModalSizePreview.value = value;
};
const programmaticallyModal = ref(false);
const setProgrammaticallyModal = (value: boolean) => {
  programmaticallyModal.value = value;
};
const warningModalPreview = ref(false);
const setWarningModalPreview = (value: boolean) => {
  warningModalPreview.value = value;
};
const buttonModalPreview = ref(false);
const setButtonModalPreview = (value: boolean) => {
  buttonModalPreview.value = value;
};
const staticBackdropModalPreview = ref(false);
const setStaticBackdropModalPreview = (value: boolean) => {
  staticBackdropModalPreview.value = value;
};
const overlappingModalPreview = ref(false);
const setOverlappingModalPreview = (value: boolean) => {
  overlappingModalPreview.value = value;
};
const nextOverlappingModalPreview = ref(false);
const setNextOverlappingModalPreview = (value: boolean) => {
  nextOverlappingModalPreview.value = value;
};
const headerFooterModalPreview = ref(false);
const setHeaderFooterModalPreview = (value: boolean) => {
  headerFooterModalPreview.value = value;
};
const deleteModalPreview = ref(false);
const setDeleteModalPreview = (value: boolean) => {
  deleteModalPreview.value = value;
};
const successModalPreview = ref(false);
const setSuccessModalPreview = (value: boolean) => {
  successModalPreview.value = value;
};
const tinySliderModalPreview = ref(false);
const setTinySliderModalPreview = (value: boolean) => {
  tinySliderModalPreview.value = value;
};
const sendButtonRef = ref(null);
const deleteButtonRef = ref(null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Preview), { class: "intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-1",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(Button), {
                      as: "a",
                      variant: "primary",
                      onClick: _cache[0] || (_cache[0] = 
                  () => {
                    setBasicModalPreview(true);
                  }
                )
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    open: basicModalPreview.value,
                    onClose: _cache[1] || (_cache[1] = 
                () => {
                  setBasicModalPreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, { class: "p-10 text-center" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" This is totally awesome blank modal! ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <!-- BEGIN: Modal Toggle -->
              <div class="text-center">
                <Button
                  as="a"
                  variant="primary"
                  @click="
                    () => {
                      setBasicModalPreview(true);
                    }
                  "
                >
                  Show Modal
                </Button>
              </div>
              <!-- END: Modal Toggle -->
              <!-- BEGIN: Modal Content -->
              <Dialog
                :open="basicModalPreview"
                @close="
                  () => {
                    setBasicModalPreview(false);
                  }
                "
              >
                <Dialog.Panel class="p-10 text-center">
                  This is totally awesome blank modal!
                </Dialog.Panel>
              </Dialog>
              <!-- END: Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Preview), { class: "mt-5 intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-2",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[2] || (_cache[2] = (event) => {
                          event.preventDefault();
                          setSmallModalSizePreview(true);
                        }),
                      class: "mb-2 mr-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Small Modal ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[3] || (_cache[3] = (event) => {
                          event.preventDefault();
                          setMediumModalSizePreview(true);
                        }),
                      class: "mb-2 mr-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Medium Modal ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[4] || (_cache[4] = (event) => {
                          event.preventDefault();
                          setLargeModalSizePreview(true);
                        }),
                      class: "mb-2 mr-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Large Modal ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[5] || (_cache[5] = (event) => {
                          event.preventDefault();
                          setSuperlargeModalSizePreview(true);
                        }),
                      class: "mb-2 mr-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Superlarge Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    size: "sm",
                    open: smallModalSizePreview.value,
                    onClose: _cache[6] || (_cache[6] = 
                () => {
                  setSmallModalSizePreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, { class: "p-10 text-center" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" This is totally awesome small modal! ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  _createVNode(_unref(Dialog), {
                    open: mediumModalSizePreview.value,
                    onClose: _cache[7] || (_cache[7] = 
                () => {
                  setMediumModalSizePreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, { class: "p-10 text-center" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" This is totally awesome medium modal! ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  _createVNode(_unref(Dialog), {
                    size: "lg",
                    open: largeModalSizePreview.value,
                    onClose: _cache[8] || (_cache[8] = 
                () => {
                  setLargeModalSizePreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, { class: "p-10 text-center" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" This is totally awesome large modal! ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  _createVNode(_unref(Dialog), {
                    size: "xl",
                    open: superlargeModalSizePreview.value,
                    onClose: _cache[9] || (_cache[9] = 
                () => {
                  setSuperlargeModalSizePreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, { class: "p-10 text-center" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" This is totally awesome superlarge modal! ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <div class="text-center">
                <!-- BEGIN: Small Modal Toggle -->
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                    event.preventDefault();
                    setSmallModalSizePreview(true);
                  }"
                  class="mb-2 mr-1"
                >
                  Show Small Modal
                </Button>
                <!-- END: Small Modal Toggle -->
                <!-- BEGIN: Medium Modal Toggle -->
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                    event.preventDefault();
                    setMediumModalSizePreview(true);
                  }"
                  class="mb-2 mr-1"
                >
                  Show Medium Modal
                </Button>
                <!-- END: Medium Modal Toggle -->
                <!-- BEGIN: Large Modal Toggle -->
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                    event.preventDefault();
                    setLargeModalSizePreview(true);
                  }"
                  class="mb-2 mr-1"
                >
                  Show Large Modal
                </Button>
                <!-- END: Large Modal Toggle -->
                <!-- BEGIN: Super Large Modal Toggle -->
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                    event.preventDefault();
                    setSuperlargeModalSizePreview(true);
                  }"
                  class="mb-2 mr-1"
                >
                  Show Superlarge Modal
                </Button>
                <!-- END: Super Large Modal Toggle -->
              </div>
              <!-- BEGIN: Small Modal Content -->
              <Dialog
                size="sm"
                :open="smallModalSizePreview"
                @close="
                  () => {
                    setSmallModalSizePreview(false);
                  }
                "
              >
                <Dialog.Panel class="p-10 text-center">
                  This is totally awesome small modal!
                </Dialog.Panel>
              </Dialog>
              <!-- END: Small Modal Content -->
              <!-- BEGIN: Medium Modal Content -->
              <Dialog
                :open="mediumModalSizePreview"
                @close="
                  () => {
                    setMediumModalSizePreview(false);
                  }
                "
              >
                <Dialog.Panel class="p-10 text-center">
                  This is totally awesome medium modal!
                </Dialog.Panel>
              </Dialog>
              <!-- END: Medium Modal Content -->
              <!-- BEGIN: Large Modal Content -->
              <Dialog
                size="lg"
                :open="largeModalSizePreview"
                @close="
                  () => {
                    setLargeModalSizePreview(false);
                  }
                "
              >
                <Dialog.Panel class="p-10 text-center">
                  This is totally awesome large modal!
                </Dialog.Panel>
              </Dialog>
              <!-- END: Large Modal Content -->
              <!-- BEGIN: Super Large Modal Content -->
              <Dialog
                size="xl"
                :open="superlargeModalSizePreview"
                @close="
                  () => {
                    setSuperlargeModalSizePreview(false);
                  }
                "
              >
                <Dialog.Panel class="p-10 text-center">
                  This is totally awesome superlarge modal!
                </Dialog.Panel>
              </Dialog>
              <!-- END: Super Large Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Preview), { class: "mt-5 intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-3" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-3",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[10] || (_cache[10] = (event) => {
                          event.preventDefault();
                          setWarningModalPreview(true);
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    open: warningModalPreview.value,
                    onClose: _cache[12] || (_cache[12] = 
                () => {
                  setWarningModalPreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_unref(Lucide), {
                              icon: "XCircle",
                              class: "w-16 h-16 mx-auto mt-3 text-warning"
                            }),
                            _hoisted_17,
                            _hoisted_18
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_unref(Button), {
                              type: "button",
                              variant: "primary",
                              onClick: _cache[11] || (_cache[11] = 
                      () => {
                        setWarningModalPreview(false);
                      }
                    ),
                              class: "w-24"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ok ")
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_20
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <!-- BEGIN: Modal Toggle -->
              <div class="text-center">
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                      event.preventDefault();
                      setWarningModalPreview(true);
                    }"
                >
                  Show Modal
                </Button>
              </div>
              <!-- END: Modal Toggle -->
              <!-- BEGIN: Modal Content -->
              <Dialog
                :open="warningModalPreview"
                @close="
                  () => {
                    setWarningModalPreview(false);
                  }
                "
              >
                <Dialog.Panel>
                  <div class="p-5 text-center">
                    <Lucide
                      icon="XCircle"
                      class="w-16 h-16 mx-auto mt-3 text-warning"
                    />
                    <div class="mt-5 text-3xl">Oops...</div>
                    <div class="mt-2 text-slate-500">Something went wrong!</div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <Button
                      type="button"
                      variant="primary"
                      @click="
                        () => {
                          setWarningModalPreview(false);
                        }
                      "
                      class="w-24"
                    >
                      Ok
                    </Button>
                  </div>
                  <div
                    class="p-5 text-center border-t border-slate-200/60 dark:border-darkmode-400"
                  >
                    <a href="" class="text-primary">
                      Why do I have this issue?
                    </a>
                  </div>
                </Dialog.Panel>
              </Dialog>
              <!-- END: Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Preview), { class: "mt-5 intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-4" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-4",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[13] || (_cache[13] = (event) => {
                          event.preventDefault();
                          setButtonModalPreview(true);
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    open: buttonModalPreview.value,
                    onClose: _cache[16] || (_cache[16] = 
                () => {
                  setButtonModalPreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[14] || (_cache[14] = (event) => {
                            event.preventDefault();
                            setButtonModalPreview(false);
                          }),
                            class: "absolute top-0 right-0 mt-3 mr-3",
                            href: "#"
                          }, [
                            _createVNode(_unref(Lucide), {
                              icon: "X",
                              class: "w-8 h-8 text-slate-400"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_unref(Lucide), {
                              icon: "CheckCircle",
                              class: "w-16 h-16 mx-auto mt-3 text-success"
                            }),
                            _hoisted_26,
                            _hoisted_27
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_unref(Button), {
                              type: "button",
                              variant: "primary",
                              onClick: _cache[15] || (_cache[15] = 
                      () => {
                        setButtonModalPreview(false);
                      }
                    ),
                              class: "w-24"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ok ")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <!-- BEGIN: Modal Toggle -->
              <div class="text-center">
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                      event.preventDefault();
                      setButtonModalPreview(true);
                    }"
                >
                  Show Modal
                </Button>
              </div>
              <!-- END: Modal Toggle -->
              <!-- BEGIN: Modal Content -->
              <Dialog
                :open="buttonModalPreview"
                @close="
                  () => {
                    setButtonModalPreview(false);
                  }
                "
              >
                <Dialog.Panel>
                  <a
                    @click="(event: MouseEvent) => {
                        event.preventDefault();
                        setButtonModalPreview(false);
                      }"
                    class="absolute top-0 right-0 mt-3 mr-3"
                    href="#"
                  >
                    <Lucide icon="X" class="w-8 h-8 text-slate-400" />
                  </a>
                  <div class="p-5 text-center">
                    <Lucide
                      icon="CheckCircle"
                      class="w-16 h-16 mx-auto mt-3 text-success"
                    />
                    <div class="mt-5 text-3xl">Modal Example</div>
                    <div class="mt-2 text-slate-500">
                      Modal with close button
                    </div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <Button
                      type="button"
                      variant="primary"
                      @click="
                        () => {
                          setButtonModalPreview(false);
                        }
                      "
                      class="w-24"
                    >
                      Ok
                    </Button>
                  </div>
                </Dialog.Panel>
              </Dialog>
              <!-- END: Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Preview), { class: "mt-5 intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-5" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-5",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_unref(Button), {
                      variant: "primary",
                      onClick: _cache[17] || (_cache[17] = 
                  () => {
                    setStaticBackdropModalPreview(true);
                  }
                )
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    staticBackdrop: "",
                    open: staticBackdropModalPreview.value,
                    onClose: _cache[19] || (_cache[19] = 
                () => {
                  setStaticBackdropModalPreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, { class: "px-5 py-10" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _createVNode(_unref(Button), {
                              type: "button",
                              variant: "primary",
                              onClick: _cache[18] || (_cache[18] = 
                      () => {
                        setStaticBackdropModalPreview(false);
                      }
                    ),
                              class: "w-24"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ok ")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <!-- BEGIN: Modal Toggle -->
              <div class="text-center">
                <Button
                  variant="primary"
                  @click="
                    () => {
                      setStaticBackdropModalPreview(true);
                    }
                  "
                >
                  Show Modal
                </Button>
              </div>
              <!-- END: Modal Toggle -->
              <!-- BEGIN: Modal Content -->
              <Dialog
                staticBackdrop
                :open="staticBackdropModalPreview"
                @close="
                  () => {
                    setStaticBackdropModalPreview(false);
                  }
                "
              >
                <Dialog.Panel class="px-5 py-10">
                  <div class="text-center">
                    <div class="mb-5">
                      I will not close if you click outside me. Don't even try
                      to press escape key.
                    </div>
                    <Button
                      type="button"
                      variant="primary"
                      @click="
                        () => {
                          setStaticBackdropModalPreview(false);
                        }
                      "
                      class="w-24"
                    >
                      Ok
                    </Button>
                  </div>
                </Dialog.Panel>
              </Dialog>
              <!-- END: Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Preview), { class: "mt-5 intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-6",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[20] || (_cache[20] = (event) => {
                          event.preventDefault();
                          setOverlappingModalPreview(true);
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    open: overlappingModalPreview.value,
                    onClose: _cache[23] || (_cache[23] = 
                () => {
                  setOverlappingModalPreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, { class: "px-5 py-10" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _createVNode(_unref(Button), {
                              as: "a",
                              href: "#",
                              variant: "primary",
                              onClick: _cache[21] || (_cache[21] = (event) => {
                              event.preventDefault();
                              setNextOverlappingModalPreview(true);
                            })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Show Overlapping Modal ")
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_unref(Dialog), {
                            open: nextOverlappingModalPreview.value,
                            onClose: _cache[22] || (_cache[22] = 
                    () => {
                      setNextOverlappingModalPreview(false);
                    }
                  )
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Dialog).Panel, { class: "p-5 text-center" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" This is totally awesome overlapping modal! ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["open"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <!-- BEGIN: Modal Toggle -->
              <div class="text-center">
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                      event.preventDefault();
                      setOverlappingModalPreview(true);
                    }"
                >
                  Show Modal
                </Button>
              </div>
              <!-- END: Modal Toggle -->
              <!-- BEGIN: Modal Content -->
              <Dialog
                :open="overlappingModalPreview"
                @close="
                  () => {
                    setOverlappingModalPreview(false);
                  }
                "
              >
                <Dialog.Panel class="px-5 py-10">
                  <div class="text-center">
                    <div class="mb-5">
                      Click button bellow to show overlapping modal!
                    </div>
                    <!-- BEGIN: Overlapping Modal Toggle -->
                    <Button
                      as="a"
                      href="#"
                      variant="primary"
                      @click="(event: MouseEvent) => {
                          event.preventDefault();
                          setNextOverlappingModalPreview(true);
                        }"
                    >
                      Show Overlapping Modal
                    </Button>
                    <!-- END: Overlapping Modal Toggle -->
                  </div>
                  <!-- BEGIN: Overlapping Modal Content -->
                  <Dialog
                    :open="nextOverlappingModalPreview"
                    @close="
                      () => {
                        setNextOverlappingModalPreview(false);
                      }
                    "
                  >
                    <Dialog.Panel class="p-5 text-center">
                      This is totally awesome overlapping modal!
                    </Dialog.Panel>
                  </Dialog>
                  <!-- END: Overlapping Modal Content -->
                </Dialog.Panel>
              </Dialog>
              <!-- END: Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createVNode(_unref(Preview), { class: "intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-7" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-7",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[24] || (_cache[24] = (event) => {
                          event.preventDefault();
                          setHeaderFooterModalPreview(true);
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    open: headerFooterModalPreview.value,
                    onClose: _cache[26] || (_cache[26] = 
                () => {
                  setHeaderFooterModalPreview(false);
                }
              ),
                    initialFocus: sendButtonRef.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Dialog).Title, null, {
                            default: _withCtx(() => [
                              _hoisted_46,
                              _createVNode(_unref(Button), {
                                variant: "outline-secondary",
                                class: "hidden sm:flex"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Lucide), {
                                    icon: "File",
                                    class: "w-4 h-4 mr-2"
                                  }),
                                  _createTextVNode(" Download Docs ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(Menu), { class: "sm:hidden" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Menu).Button, {
                                    class: "block w-5 h-5",
                                    href: "#"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Lucide), {
                                        icon: "MoreHorizontal",
                                        class: "w-5 h-5 text-slate-500"
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(Menu).Items, { class: "w-40" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Menu).Item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Lucide), {
                                            icon: "File",
                                            class: "w-4 h-4 mr-2"
                                          }),
                                          _createTextVNode(" Download Docs ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(Dialog).Description, { class: "grid grid-cols-12 gap-4 gap-y-3" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_47, [
                                _createVNode(_unref(FormLabel), { htmlFor: "modal-form-1" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("From")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(FormInput), {
                                  id: "modal-form-1",
                                  type: "text",
                                  placeholder: "example@gmail.com"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_48, [
                                _createVNode(_unref(FormLabel), { htmlFor: "modal-form-2" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("To")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(FormInput), {
                                  id: "modal-form-2",
                                  type: "text",
                                  placeholder: "example@gmail.com"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _createVNode(_unref(FormLabel), { htmlFor: "modal-form-3" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Subject ")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(FormInput), {
                                  id: "modal-form-3",
                                  type: "text",
                                  placeholder: "Important Meeting"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _createVNode(_unref(FormLabel), { htmlFor: "modal-form-4" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Has the Words ")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(FormInput), {
                                  id: "modal-form-4",
                                  type: "text",
                                  placeholder: "Job, Work, Documentation"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(_unref(FormLabel), { htmlFor: "modal-form-5" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Doesn't Have ")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(FormInput), {
                                  id: "modal-form-5",
                                  type: "text",
                                  placeholder: "Job, Work, Documentation"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _createVNode(_unref(FormLabel), { htmlFor: "modal-form-6" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Size")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(FormSelect), { id: "modal-form-6" }, {
                                  default: _withCtx(() => [
                                    _hoisted_53,
                                    _hoisted_54,
                                    _hoisted_55,
                                    _hoisted_56
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(Dialog).Footer, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Button), {
                                type: "button",
                                variant: "outline-secondary",
                                onClick: _cache[25] || (_cache[25] = 
                      () => {
                        setHeaderFooterModalPreview(false);
                      }
                    ),
                                class: "w-20 mr-1"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Cancel ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(Button), {
                                variant: "primary",
                                type: "button",
                                class: "w-20",
                                ref: "{sendButtonRef}"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Send ")
                                ]),
                                _: 1
                              }, 512)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open", "initialFocus"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <!-- BEGIN: Modal Toggle -->
              <div class="text-center">
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                      event.preventDefault();
                      setHeaderFooterModalPreview(true);
                    }"
                >
                  Show Modal
                </Button>
              </div>
              <!-- END: Modal Toggle -->
              <!-- BEGIN: Modal Content -->
              <Dialog
                :open="headerFooterModalPreview"
                @close="
                  () => {
                    setHeaderFooterModalPreview(false);
                  }
                "
                :initialFocus="sendButtonRef"
              >
                <Dialog.Panel>
                  <Dialog.Title>
                    <h2 class="mr-auto text-base font-medium">
                      Broadcast Message
                    </h2>
                    <Button variant="outline-secondary" class="hidden sm:flex">
                      <Lucide icon="File" class="w-4 h-4 mr-2" /> Download Docs
                    </Button>
                    <Menu class="sm:hidden">
                      <Menu.Button class="block w-5 h-5" href="#">
                        <Lucide
                          icon="MoreHorizontal"
                          class="w-5 h-5 text-slate-500"
                        />
                      </Menu.Button>
                      <Menu.Items class="w-40">
                        <Menu.Item>
                          <Lucide icon="File" class="w-4 h-4 mr-2" />
                          Download Docs
                        </Menu.Item>
                      </Menu.Items>
                    </Menu>
                  </Dialog.Title>
                  <Dialog.Description class="grid grid-cols-12 gap-4 gap-y-3">
                    <div class="col-span-12 sm:col-span-6">
                      <FormLabel htmlFor="modal-form-1"> From </FormLabel>
                      <FormInput
                        id="modal-form-1"
                        type="text"
                        placeholder="example@gmail.com"
                      />
                    </div>
                    <div class="col-span-12 sm:col-span-6">
                      <FormLabel htmlFor="modal-form-2"> To </FormLabel>
                      <FormInput
                        id="modal-form-2"
                        type="text"
                        placeholder="example@gmail.com"
                      />
                    </div>
                    <div class="col-span-12 sm:col-span-6">
                      <FormLabel htmlFor="modal-form-3"> Subject </FormLabel>
                      <FormInput
                        id="modal-form-3"
                        type="text"
                        placeholder="Important Meeting"
                      />
                    </div>
                    <div class="col-span-12 sm:col-span-6">
                      <FormLabel htmlFor="modal-form-4">
                        Has the Words
                      </FormLabel>
                      <FormInput
                        id="modal-form-4"
                        type="text"
                        placeholder="Job, Work, Documentation"
                      />
                    </div>
                    <div class="col-span-12 sm:col-span-6">
                      <FormLabel htmlFor="modal-form-5">
                        Doesn't Have
                      </FormLabel>
                      <FormInput
                        id="modal-form-5"
                        type="text"
                        placeholder="Job, Work, Documentation"
                      />
                    </div>
                    <div class="col-span-12 sm:col-span-6">
                      <FormLabel htmlFor="modal-form-6"> Size </FormLabel>
                      <FormSelect id="modal-form-6">
                        <option>10</option>
                        <option>25</option>
                        <option>35</option>
                        <option>50</option>
                      </FormSelect>
                    </div>
                  </Dialog.Description>
                  <Dialog.Footer>
                    <Button
                      type="button"
                      variant="outline-secondary"
                      @click="
                        () => {
                          setHeaderFooterModalPreview(false);
                        }
                      "
                      class="w-20 mr-1"
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      type="button"
                      class="w-20"
                      ref="{sendButtonRef}"
                    >
                      Send
                    </Button>
                  </Dialog.Footer>
                </Dialog.Panel>
              </Dialog>
              <!-- END: Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Preview), { class: "mt-5 intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-9" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-9",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_60, [
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[27] || (_cache[27] = (event) => {
                          event.preventDefault();
                          setDeleteModalPreview(true);
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    open: deleteModalPreview.value,
                    onClose: _cache[29] || (_cache[29] = 
                () => {
                  setDeleteModalPreview(false);
                }
              ),
                    initialFocus: deleteButtonRef.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_61, [
                            _createVNode(_unref(Lucide), {
                              icon: "XCircle",
                              class: "w-16 h-16 mx-auto mt-3 text-danger"
                            }),
                            _hoisted_62,
                            _hoisted_63
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_unref(Button), {
                              type: "button",
                              variant: "outline-secondary",
                              onClick: _cache[28] || (_cache[28] = 
                      () => {
                        setDeleteModalPreview(false);
                      }
                    ),
                              class: "w-24 mr-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Cancel ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Button), {
                              type: "button",
                              variant: "danger",
                              class: "w-24",
                              ref: "{deleteButtonRef}"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Delete ")
                              ]),
                              _: 1
                            }, 512)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open", "initialFocus"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <!-- BEGIN: Modal Toggle -->
              <div class="text-center">
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                      event.preventDefault();
                      setDeleteModalPreview(true);
                    }"
                >
                  Show Modal
                </Button>
              </div>
              <!-- END: Modal Toggle -->
              <!-- BEGIN: Modal Content -->
              <Dialog
                :open="deleteModalPreview"
                @close="
                  () => {
                    setDeleteModalPreview(false);
                  }
                "
                :initialFocus="deleteButtonRef"
              >
                <Dialog.Panel>
                  <div class="p-5 text-center">
                    <Lucide
                      icon="XCircle"
                      class="w-16 h-16 mx-auto mt-3 text-danger"
                    />
                    <div class="mt-5 text-3xl">Are you sure?</div>
                    <div class="mt-2 text-slate-500">
                      Do you really want to delete these records? <br />
                      This process cannot be undone.
                    </div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <Button
                      type="button"
                      variant="outline-secondary"
                      @click="
                        () => {
                          setDeleteModalPreview(false);
                        }
                      "
                      class="w-24 mr-1"
                    >
                      Cancel
                    </Button>
                    <Button
                      type="button"
                      variant="danger"
                      class="w-24"
                      ref="{deleteButtonRef}"
                    >
                      Delete
                    </Button>
                  </div>
                </Dialog.Panel>
              </Dialog>
              <!-- END: Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Preview), { class: "mt-5 intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-10",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[30] || (_cache[30] = (event) => {
                          event.preventDefault();
                          setSuccessModalPreview(true);
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    open: successModalPreview.value,
                    onClose: _cache[32] || (_cache[32] = 
                () => {
                  setSuccessModalPreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_69, [
                            _createVNode(_unref(Lucide), {
                              icon: "CheckCircle",
                              class: "w-16 h-16 mx-auto mt-3 text-success"
                            }),
                            _hoisted_70,
                            _hoisted_71
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_unref(Button), {
                              type: "button",
                              variant: "primary",
                              onClick: _cache[31] || (_cache[31] = 
                      () => {
                        setSuccessModalPreview(false);
                      }
                    ),
                              class: "w-24"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ok ")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <!-- BEGIN: Modal Toggle -->
              <div class="text-center">
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                      event.preventDefault();
                      setSuccessModalPreview(true);
                    }"
                >
                  Show Modal
                </Button>
              </div>
              <!-- END: Modal Toggle -->
              <!-- BEGIN: Modal Content -->
              <Dialog
                :open="successModalPreview"
                @close="
                  () => {
                    setSuccessModalPreview(false);
                  }
                "
              >
                <Dialog.Panel>
                  <div class="p-5 text-center">
                    <Lucide
                      icon="CheckCircle"
                      class="w-16 h-16 mx-auto mt-3 text-success"
                    />
                    <div class="mt-5 text-3xl">Good job!</div>
                    <div class="mt-2 text-slate-500">
                      You clicked the button!
                    </div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <Button
                      type="button"
                      variant="primary"
                      @click="
                        () => {
                          setSuccessModalPreview(false);
                        }
                      "
                      class="w-24"
                    >
                      Ok
                    </Button>
                  </div>
                </Dialog.Panel>
              </Dialog>
              <!-- END: Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Preview), { class: "mt-5 intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-11" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-11",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_76, [
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      onClick: _cache[33] || (_cache[33] = (event) => {
                          event.preventDefault();
                          setTinySliderModalPreview(true);
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    open: tinySliderModalPreview.value,
                    onClose: _cache[34] || (_cache[34] = 
                () => {
                  setTinySliderModalPreview(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, { class: "p-5" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_unref(TinySlider), { options: {
                      mouseDrag: true,
                      autoplay: false,
                      controls: true,
                      center: true,
                      items: 1,
                      nav: false,
                      speed: 500,
                      responsive: {
                        600: {
                          items: 2,
                        },
                      },
                    } }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_78, [
                                  _createElementVNode("div", _hoisted_79, [
                                    _createElementVNode("img", {
                                      alt: "Midone Tailwind HTML Admin Template",
                                      src: _unref(fakerData)[0].images[0]
                                    }, null, 8, _hoisted_80)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_81, [
                                  _createElementVNode("div", _hoisted_82, [
                                    _createElementVNode("img", {
                                      alt: "Midone Tailwind HTML Admin Template",
                                      src: _unref(fakerData)[0].images[1]
                                    }, null, 8, _hoisted_83)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("img", {
                                      alt: "Midone Tailwind HTML Admin Template",
                                      src: _unref(fakerData)[0].images[2]
                                    }, null, 8, _hoisted_86)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_87, [
                                  _createElementVNode("div", _hoisted_88, [
                                    _createElementVNode("img", {
                                      alt: "Midone Tailwind HTML Admin Template",
                                      src: _unref(fakerData)[0].images[3]
                                    }, null, 8, _hoisted_89)
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <!-- BEGIN: Modal Toggle -->
              <div class="text-center">
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  @click="(event: MouseEvent) => {
                      event.preventDefault();
                      setTinySliderModalPreview(true);
                    }"
                >
                  Show Modal
                </Button>
              </div>
              <!-- END: Modal Toggle -->
              <!-- BEGIN: Modal Content -->
              <Dialog
                :open="tinySliderModalPreview"
                @close="
                  () => {
                    setTinySliderModalPreview(false);
                  }
                "
              >
                <Dialog.Panel class="p-5">
                  <div class="mx-6">
                    <TinySlider
                      :options="{
                        mouseDrag: true,
                        autoplay: false,
                        controls: true,
                        center: true,
                        items: 1,
                        nav: false,
                        speed: 500,
                        responsive: {
                          600: {
                            items: 2,
                          },
                        },
                      }"
                    >
                      <div class="h-56 px-2">
                        <div
                          class="h-full overflow-hidden rounded-md image-fit"
                        >
                          <img
                            alt="Midone Tailwind HTML Admin Template"
                            :src="fakerData[0].images[0]"
                          />
                        </div>
                      </div>
                      <div class="h-56 px-2">
                        <div
                          class="h-full overflow-hidden rounded-md image-fit"
                        >
                          <img
                            alt="Midone Tailwind HTML Admin Template"
                            :src="fakerData[0].images[1]"
                          />
                        </div>
                      </div>
                      <div class="h-56 px-2">
                        <div
                          class="h-full overflow-hidden rounded-md image-fit"
                        >
                          <img
                            alt="Midone Tailwind HTML Admin Template"
                            :src="fakerData[0].images[2]"
                          />
                        </div>
                      </div>
                      <div class="h-56 px-2">
                        <div
                          class="h-full overflow-hidden rounded-md image-fit"
                        >
                          <img
                            alt="Midone Tailwind HTML Admin Template"
                            :src="fakerData[0].images[3]"
                          />
                        </div>
                      </div>
                    </TinySlider>
                  </div>
                </Dialog.Panel>
              </Dialog>
              <!-- END: Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Preview), { class: "mt-5 intro-y box" }, {
          default: _withCtx(({ toggle }) => [
            _createElementVNode("div", _hoisted_90, [
              _hoisted_91,
              _createVNode(_unref(FormSwitch), { class: "w-full mt-3 sm:w-auto sm:ml-auto sm:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormSwitch).Label, { htmlFor: "show-example-12" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show example code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormSwitch).Input, {
                    id: "show-example-12",
                    onClick: toggle,
                    class: "ml-3 mr-0",
                    type: "checkbox"
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_92, [
              _createVNode(_unref(Preview).Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_93, [
                    _createVNode(_unref(Button), {
                      as: "a",
                      href: "#",
                      variant: "primary",
                      class: "mb-2 mr-1",
                      onClick: _cache[35] || (_cache[35] = (event) => {
                          event.preventDefault();
                          setProgrammaticallyModal(true);
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Modal ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(Dialog), {
                    open: programmaticallyModal.value,
                    onClose: _cache[38] || (_cache[38] = 
                () => {
                  setProgrammaticallyModal(false);
                }
              )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Dialog).Panel, { class: "p-10 text-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Button), {
                            as: "a",
                            href: "#",
                            variant: "primary",
                            class: "mr-1",
                            onClick: _cache[36] || (_cache[36] = (event) => {
                            event.preventDefault();
                            setProgrammaticallyModal(false);
                          })
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Hide Modal ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(Button), {
                            as: "a",
                            href: "#",
                            variant: "primary",
                            class: "mr-1",
                            onClick: _cache[37] || (_cache[37] = (event) => {
                            event.preventDefault();
                            setProgrammaticallyModal(!programmaticallyModal.value);
                          })
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Toggle Modal ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["open"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Preview).Panel, { type: "source" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Preview).Highlight, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`
              <!-- BEGIN: Show Modal Toggle -->
              <div class="text-center">
                <Button
                  as="a"
                  href="#"
                  variant="primary"
                  class="mb-2 mr-1"
                  @click="(event: MouseEvent) => {
                      event.preventDefault();
                      setProgrammaticallyModal(true);
                    }"
                >
                  Show Modal
                </Button>
              </div>
              <!-- END: Show Modal Toggle -->
              <!-- BEGIN: Modal Content -->
              <Dialog
                :open="programmaticallyModal"
                @close="
                  () => {
                    setProgrammaticallyModal(false);
                  }
                "
              >
                <Dialog.Panel class="p-10 text-center">
                  <!-- BEGIN: Hide Modal Toggle -->
                  <Button
                    as="a"
                    href="#"
                    variant="primary"
                    class="mr-1"
                    @click="(event: MouseEvent) => {
                        event.preventDefault();
                        setProgrammaticallyModal(false);
                      }"
                  >
                    Hide Modal
                  </Button>
                  <!-- END: Hide Modal Toggle -->
                  <!-- BEGIN: Toggle Modal Toggle -->
                  <Button
                    as="a"
                    href="#"
                    variant="primary"
                    class="mr-1"
                    @click="(event: MouseEvent) => {
                        event.preventDefault();
                        setProgrammaticallyModal(!programmaticallyModal);
                      }"
                  >
                    Toggle Modal
                  </Button>
                  <!-- END: Toggle Modal Toggle -->
                </Dialog.Panel>
              </Dialog>
              <!-- END: Modal Content -->
              `), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})